import { PostHogProvider } from "posthog-js/react";
import React, { PropsWithChildren } from "react";

export function PostHogProviderWrapper({ children }: PropsWithChildren) {
  if (__DEV__) {
    return <>{children}</>;
  }

  const apiKey = process.env.EXPO_PUBLIC_POSTHOG_API_KEY;
  if (!apiKey) {
    throw new Error(
      "Missing API Key. Please set EXPO_PUBLIC_POSTHOG_API_KEY in your .env"
    );
  }

  const host = process.env.EXPO_PUBLIC_POSTHOG_HOST;
  if (!host) {
    throw new Error(
      "Missing Host. Please set EXPO_PUBLIC_POSTHOG_HOST in your .env"
    );
  }

  return (
    <PostHogProvider
      apiKey={apiKey}
      options={{
        autocapture: false,
        rageclick: true,
        debug: false,
        api_host: host,
        disable_session_recording: false, // manually capture page views, autocapture missed some when testing
        capture_pageview: false,
        capture_pageleave: false,
        session_recording: {
          maskAllInputs: false,
          maskInputOptions: {
            password: true,
          },
        },
      }}
    >
      {children}
    </PostHogProvider>
  );
}
